<template>
  <div id="simpleend" class="simpleend">
  </div>
</template>

<script src="https://unpkg.com/@microsoft/teams-js@1.3.7/dist/MicrosoftTeams.min.js"></script>
<script>
  export default {
    name: 'SimpleEnd',
    created () {
      microsoftTeams.initialize();
      localStorage.removeItem("simple.error");

      let hashParams = getHashParameters();
      if (hashParams["error"]) {
        localStorage.setItem("simple.error", JSON.stringify(hashParams));
        microsoftTeams.authentication.notifyFailure(hashParams["error"]);
      } else if (hashParams["access_token"]) {
        // Get the stored state parameter and compare with incoming state
        let expectedState = localStorage.getItem("simple.state");
        let key = "simple.result";
        localStorage.setItem(key, JSON.stringify({
          idToken: hashParams["id_token"],
          accessToken: hashParams["access_token"],
          tokenType: hashParams["token_type"],
          expiresIn: hashParams["expires_in"],
          tenantId: JSON.parse(atob(JSON.stringify(hashParams["id_token"]).split('.')[1]))['tid']
        }));
        microsoftTeams.authentication.notifySuccess(key);
      } else {
        // Unexpected condition: hash does not contain error or access_token parameter
        localStorage.setItem("simple.error", JSON.stringify(hashParams));
        microsoftTeams.authentication.notifyFailure("UnexpectedFailure");
      }

      // Parse hash parameters into key-value pairs
      function getHashParameters() {
        let hashParams = {};
        location.hash.substr(1).split("&").forEach(function(item) {
          let s = item.split("="),
            k = s[0],
            v = s[1] && decodeURIComponent(s[1]);
          hashParams[k] = v;
        });
        return hashParams;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/SimpleEnd.vue